import { GlobalAdapter } from "@core/store/adapters/global.adapter";
import { UsersState } from "@modules/users/entities";
import * as UsersAction from "@modules/users/store/actions/users.action";
import { Action, createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";

const initialState: UsersState = {
  ui: {
    isLoading: true,
    isForm: false,
    isModal: false,
    loaderBtn: false,
    loaderBtnModal: false,
  },
  users: [],
  selected_user: null,
  selected_retailers: [],
};

const usersReduce = createReducer(
  initialState,
  on(UsersAction.clearAll, () => initialState),
  on(UsersAction.uiUsers, (state, { ui }) => GlobalAdapter.setUi(ui, state)),
  on(UsersAction.setUsers, (state, { payload }) => ({ ...state, users: payload })),
  on(UsersAction.setSelectedUser, (state, { payload }) => ({ ...state, selected_user: payload })),
  on(UsersAction.modifySelectedRetailers, (state, { payload }) => ({...state, selected_retailers: payload}))
);

export function UsersReducer(state: UsersState, action: Action) {
  return usersReduce(state, action);
}

export const getUsersStore = createFeatureSelector<UsersState>("users");

export const getUiUsers = createSelector(getUsersStore, ({ ui }) => ui);
export const getAllUsers = createSelector(getUsersStore, ({ users }) => users);
export const getSelectedUser = createSelector(getUsersStore, ({ selected_user }) => selected_user);
export const getSelectedRetailers = createSelector(getUsersStore, ({ selected_retailers }) => selected_retailers);
